import { AddCompositeSegmentDeleteAction, AddCompositeSegmentDeleteWordsAction } from './types';
import { getAllCompositeSegments } from '../clipUpdateDataUtilsWithSplits/compositeUtils';
import { Clip, ClipDeletes } from '@/domains/asset';
import { roundToNDecimalPlaces } from '@/libs/utils';
import { mergeDeletes } from '@/components/molecules/Transcript/EditTranscriptMenu/utils';

export const getClipCompositeSegment = (newClip: Clip) => {
  const allCompositeSegments = getAllCompositeSegments(newClip);

  if (allCompositeSegments.length === 0) {
    throw new Error('No composite segment found');
  }
  return allCompositeSegments[0];
};

export const addCompositeSegmentDelete = (
  clip: Clip,
  updateClipPayload: AddCompositeSegmentDeleteAction | AddCompositeSegmentDeleteWordsAction
) => {
  const { startTime, endTime } = updateClipPayload;
  const absoluteStartTime = roundToNDecimalPlaces(Math.min(startTime, endTime), 3);
  const absoluteEndTime = roundToNDecimalPlaces(Math.max(startTime, endTime), 3);

  const newDeletes: ClipDeletes = {
    ...(clip.asset_metadata.deletes || {}),
    [absoluteStartTime]: {
      bounds: [absoluteStartTime, absoluteEndTime],
      prev_end_time: absoluteStartTime,
      next_start_time: absoluteEndTime,
      deleteType: updateClipPayload.deleteType
    }
  };

  const mergeDeletesData = mergeDeletes(newDeletes);
  clip.asset_metadata.deletes = mergeDeletesData;

  if (absoluteStartTime <= clip.asset_metadata.start && absoluteEndTime >= clip.asset_metadata.start) {
    clip.asset_metadata.start = absoluteEndTime;
  }
  if (absoluteEndTime >= clip.asset_metadata.end && absoluteStartTime <= clip.asset_metadata.end) {
    clip.asset_metadata.end = absoluteStartTime;
  }
  return clip;
};
